import React from 'react'
import LocationMap from '../Modal'
import SectionTitleS2 from '../SectionTitleS2'
import { Link } from 'react-scroll'


const Events = [
    {
        title: 'Preboda',
        li1: 'Viernes, 20 Jun, 2025',
        li2: '8:00 PM',
        li3: 'Lugar: Aún por concretar'
    },
    {
        title: 'Boda',
        li1: 'Sábado, 21 Jun, 2025',
        li2: '8:00 PM – 4:00 AM',
        li3: 'Hotel HO Ciudad de Jaén'
    }

]

const EventSection = (props) => {
    return (
        <section className={`wpo-event-section section-padding ${props.eClass}`} id="event">
            <div className="container">
                <SectionTitleS2 MainTitle={'Cuándo y dónde'} />
                <div className="wpo-event-wrap">
                    <div className="row  justify-content-center">
                        {Events.map((event, eitem) => (
                            <div className="col col-lg-4 col-md-6 col-12" key={eitem}>
                                <div className="wpo-event-item">
                                    <div className="wpo-event-text">
                                        <h2>{event.title}</h2>
                                        <ul>
                                            <li>{event.li1}</li>
                                            <li style={{ fontWeight: '500' }}>{event.li2}</li>
                                            <li style={{fontStyle: 'italic'}}>{event.li3}</li>
                                            {event.title != 'Preboda' ?
                                                <div>
                                                    {/* <Link className="theme-btn" to="hotel" spy={true} smooth={true} duration={500} ><span className="text">RESERVAR HABITACIÓN</span> <span className="mobile">
                                                    </span></Link> */}
                                                    <li><LocationMap /></li>
                                                </div>
                                                :
                                                <div>
                                                    {/* <Link className="theme-btn" to="preboda" spy={true} smooth={true} duration={500} ><span className="text">APÚNTANTE</span> <span className="mobile">
                                                    </span></Link> */}
                                                </div>
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default EventSection;